import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressInfo, FulfillmentLocation, SlaInfo } from '../../order-v2.types';
import { SlaCardComponent } from './sla-card/sla-card.component';
import { DeliveryAddressCardComponent } from './delivery-address-card/delivery-address-card.component';
import { PickupAddressCardComponent } from './pickup-address-card/pickup-address-card.component';
import { FulfillmentLocationCardComponent } from './fulfillment-location-card/fulfillment-location-card.component';

@Component({
  selector: 'app-logistics-section',
  standalone: true,
  imports: [
    CommonModule,
    SlaCardComponent,
    DeliveryAddressCardComponent,
    PickupAddressCardComponent,
    FulfillmentLocationCardComponent,
  ],
  templateUrl: './logistics-section.component.html',
  styleUrl: './logistics-section.component.scss',
})
export class LogisticsSectionComponent {
  @Input({ required: true }) modality!: string;
  @Input({ required: true }) deliveryDate!: string;
  @Input({ required: true }) sla!: SlaInfo;
  @Input({ required: true }) address!: AddressInfo;
  @Input({ required: true }) expeditionLocation!: FulfillmentLocation | null;
  @Input({ required: true }) replenishmentLocation!: FulfillmentLocation | null;
}
